import queryString from "query-string";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AuthRedirect = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { mode, oobCode } = queryString.parse(search);

  useEffect(() => {
    if (mode === "resetPassword") {
      navigate({ pathname: `/confirm-password`, search: `?oobCode=${oobCode}` });
    }
  }, []);

  return null;
};

export default AuthRedirect;
